import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/auth";
import {
  showCustomToast,
  CustomToastContainer,
} from "../components/CustomToast";
import { AiOutlineAppstore, AiOutlineLoading } from "react-icons/ai";
import TermsModal from "../components/TermsModal";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="text-center">
        <AiOutlineLoading
          className="mx-auto mb-4 text-white animate-spin"
          size={64}
        />
        <p className="text-white text-xl font-semibold">
          Processing your application...
        </p>
        <p className="text-white text-sm mt-2">
          Please do not close the window
        </p>
      </div>
    </div>
  );
};
const Common_form = ({ application_type, formprice }) => {
  // Define the initial form data
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [auth] = useAuth(); // Access auth state from context
  const isLoggedIn = Boolean(auth.token); // Determine if user is logged in based on token
  const [formPrices, setFormPrices] = useState({}); // State for form prices
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [txn_id, setTxnId] = useState(null);
  const [transactionID, setTransactionID] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const [error, setError] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);

  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isTermsActive, setIsTermsActive] = useState(false);
  const [wasTermsModalOpened, setWasTermsModalOpened] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // Show the modal if the user is not logged in
    if (!isLoggedIn) {
      setIsModalOpen(true); // Show the modal if not logged in
    }
  }, [isLoggedIn]); // Run effect whenever isLoggedIn changes
  const closeModal = () => {
    setIsModalOpen(false); // Function to close modal
  };
  const handleChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    if (isTermsActive) {
      setIsChecked(true);
    }
  }, [isTermsActive]);
  // Function to open terms modal
  const openTermsModal = (e) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };
  // Function to track when the modal is opened
  const handleTermsModalOpen = () => {
    setWasTermsModalOpened(true);
  };

  useEffect(() => {
    const fetchFormPrice = async () => {
      try {
        // First try to fetch specific price
        const response = await axios.get(
        `https://api.makeeasydocuments.com/api/formprices/getallformprice/${formprice}`
        );
        console.log("application name", application_type);
        if (response.data) {
          setSelectedPrice(response.data.price);
          console.log("response data price", response.data.price);
          setFormPrices({ [formprice]: response.data.price });
        }
      } catch (error) {
        console.error("Error fetching form price:", error);
        // Fallback to fetching all prices
        try {
          const allPricesResponse = await axios.get(
            "https://api.makeeasydocuments.com/api/formprices/getallformprice"
          );
          const prices = allPricesResponse.data.reduce((acc, formPrice) => {
            acc[formPrice.formType] = formPrice.price;
            return acc;
          }, {});
          setFormPrices(prices);

          // Try to find matching price
          const matchingPrice = allPricesResponse.data.find(
            (fp) =>
              fp.formType.toLowerCase() ===
              application_type.replace(/\s+/g, "").toLowerCase()
          );
          if (matchingPrice) {
            setSelectedPrice(matchingPrice.price);
          } else {
            showCustomToast("Price not found for this form type.", "warning");
            setSelectedPrice(0);
          }
        } catch (fallbackError) {
          console.error("Error fetching all form prices:", fallbackError);
          showCustomToast("Error fetching form prices.", "error");
        }
      }
    };
    if (application_type) {
      fetchFormPrice();
    }
  }, [application_type]);
  const initialFormData = {
    fullName: "",
    email: "",
    address: "",
    state: "",
    pincode: "",
    mobileNumber: "",
    dateOfBirth: "",
    application_type: application_type || "Common Form", // Ensure it defaults to an empty string
  };
  const [formData, setFormData] = useState(initialFormData);
  const generateTransactionID = () => {
    const timeStamp = Date.now();
    const randomNum = Math.floor(Math.random() * 1000000);
    const merchantPrefix = "T";
    const transactionID = `${merchantPrefix}${timeStamp}${randomNum} `;
    console.log("transaction", transactionID);
    return transactionID;
  };
  useEffect(() => {
    setTransactionID(generateTransactionID());
  }, []);
  // Update formData when application_type prop changes
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      application_type: application_type || "Common Form", // Update if the prop changes
    }));
  }, [application_type]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Check if the terms modal was opened
    if (!wasTermsModalOpened) {
      alert("Please open the terms and conditions modal before submitting.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    // Check if the terms and conditions checkbox is checked
    if (!isChecked) {
      alert("Please agree to the terms and conditions by checking the box.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    if (!isChecked) {
      setError(true);
      return;
    }
    console.log("Form data before submission:", formData); // Log the form data
    // Check if user is authenticated
    if (!auth.token) {
      showCustomToast("Please log in to fill out the form.", "error");
      return;
    }
    setIsLoading(true);
    // Create the form data object with the transaction ID included
    const formDataToSubmit = {
      ...formData,
      transactionId: transactionID, // Include the transaction ID in the request body
    };
    console.log("form data before sending", formDataToSubmit);
    try {
      // Set up headers for the request
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`, // Include the token in the header if needed
        },
      };
      const response = await axios.post(
        "https://api.makeeasydocuments.com/api/commonForm/createcommon-form",
        formDataToSubmit,
        config // Include the config object
      );
      let formID;
      let userId;
      if (
        response.data &&
        response.data.newCommonForm &&
        response.data.newCommonForm._id
      ) {
        // Extract the form ID from the response
        formID = response.data.newCommonForm._id;
        userId = response.data.newCommonForm.user;
        console.log("Form ID:", formID);
        //
      } else {
        console.error("Unexpected response format:", response.data);
      }
      // Proceed with the PayU payment logic after form submission
      const payuResponse = await axios.post(
        "https://api.makeeasydocuments.com/api/payu/hash",
        {
          formId: formID, // 👈 Add this line to send formId
          formType: application_type,
          fullName: formData.fullName,
          email: formData.email,
          amount: selectedPrice,
          transactionID,
          udf1: "detail 1",
          udf2: "detail 2",
          udf3: "",
          udf4: "",
          udf5: "",
        }
      );
      const { hash } = payuResponse.data;
      const payuForm = document.createElement("form");
      payuForm.action = "http://localhost:4001/get-payment";
      payuForm.method = "POST";
      const fields = {
        userId: userId,
        formId: formID,
        formType: application_type,
        key: "nC1EmY",
        txnid: transactionID,
        amount: selectedPrice,
        productinfo: application_type,
        firstname: formData.fullName,
        email: formData.email,
        phone: formData.mobileNumber,
        surl: `https://makeeasydocuments.com/success_payment?txnid=${txn_id}`, // Frontend success page
        furl: `https://makeeasydocuments.com/payment-failed`, // Frontend failure page
        hash: hash,
        udf1: "detail 1",
        udf2: "detail 2",
        udf3: "",
        udf4: "",
        udf5: "",
      };
      for (const key in fields) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = fields[key];
        payuForm.appendChild(input);
      }
      document.body.appendChild(payuForm);
      payuForm.submit();
      // showCustomToast("Form submitted successfully!");
      console.log(response.data); // Handle the response as needed
      // Reset the form fields to their initial state after successful submission
      setFormData(initialFormData);
    } catch (error) {
      showCustomToast("Error submitting the form. Please try again.", "error");
      console.error(error.response ? error.response.data : error); // Handle the error as needed
    } finally {
      setIsLoading(false); // Stop the loading spinner in both success and error cases
    }
  };
  return (
    <div>
      {isLoading && <FullScreenLoader />}
      {/* Left side - Form */}
      <div className="bg-white p-10 rounded-lg shadow-xl">
        <form onSubmit={handleSubmit}>
          <br />
          <div className="flex flex-col sm:flex-row sm:justify-between mt-10 pb-6">
            <h2 className="text-green-600 font-semibold text-xl text-center sm:text-left">
              Service Charge :{" "}
              <span className="text-red-600" id="formprice">
                {" "}
                ₹ {selectedPrice}
              </span>
            </h2>
          </div>{" "}
          <br />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Enter Full Name
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="---"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Your Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="example@gmail.com" // Placeholder for guidance
                className={`w-full border ${
                  formData.email && !formData.email.includes("@")
                    ? "border-red-500"
                    : "border-gray-300"
                } rounded px-3 py-2 focus:outline-none`}
                required
                pattern="[a-zA-Z0-9._%+-]+@gmail\.com" // Regex pattern for Gmail addresses
                title="Please enter a valid Gmail address." // Error message for invalid input
                onBlur={(e) => {
                  // Validate on input blur
                  if (!e.target.value.includes("@")) {
                    e.target.setCustomValidity(
                      'You must include "@" in your email.'
                    );
                  } else {
                    e.target.setCustomValidity(""); // Clear the error
                  }
                }}
              />
              {formData.email && !formData.email.includes("@") && (
                <span className="text-red-500 text-xs mt-1">
                  Email must contain "@"
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="---"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                placeholder="---"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Pincode
              </label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleInputChange}
                placeholder="---"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                pattern="\d{6}" // Require exactly 6 digits
                maxLength="6"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 6);
                }}
                required
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Mobile Number
              </label>
              <input
                type="text"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleInputChange}
                placeholder="---"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                } // Only allows digits
                pattern="[0-9]{10}"
                maxLength="10"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Date of Birth
              </label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                required
              />
            </div>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                className="w-4 h-4"
                required
                checked={isChecked}
                onChange={(e) => {
                  if (wasTermsModalOpened) {
                    setIsChecked(e.target.checked);
                  } else {
                    alert(
                      "Please open the terms and conditions modal before checking the box."
                    );
                  }
                }}
              />
              <span>
                {" "}
                I agree to submit this form and accept the{" "}
                <a
                  href="#"
                  onClick={openTermsModal}
                  className="text-blue-600 underline"
                >
                  <br />
                  terms & conditions
                </a>
                .
              </span>
            </label>

            {/* Terms Modal Component with tracking callback */}
            <TermsModal
              isOpen={isTermsModalOpen}
              setIsOpen={setIsTermsModalOpen}
              setIsTermsActive={setIsTermsActive}
              onModalOpen={handleTermsModalOpen}
            />
          </div>
          <div className="text-center mt-6">
            <button
              type="submit"
              disabled={isLoading}
              className={`
                            bg-green-600 text-white py-2 px-4 rounded 
                            ${
                              isLoading
                                ? "opacity-50 cursor-not-allowed"
                                : "hover:bg-green-700"
                            }
                            flex items-center justify-center mx-auto
                        `}
            >
              {isLoading ? (
                <>
                  <AiOutlineLoading className="mr-2 animate-spin" />
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
      <CustomToastContainer />
    </div>
  );
};
export default Common_form;
